import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import { store } from '@/store'
import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition'
import ProgressBar from 'vuejs-progress-bar'
import { PermissionPlugin } from '@/directives/permission'
import { ToastPlugin } from '@/plugins/toast'
import { copyToClipboard } from '@/utils/clipboard'
import '@/assets/css/page.css'
import '@/assets/print.css'
import PageDesc from '@/components/common/PageDesc.vue'

const bounceTransition = createSimpleTransition('bounce-transition')

Vue.component('BounceTransition', bounceTransition)
Vue.component('PageDesc', PageDesc)

Vue.config.productionTip = false

Vue.use(ProgressBar)
Vue.use(PermissionPlugin)
Vue.use(ToastPlugin)

Vue.mixin({
  methods: {
    addrCopy(addr) {
      copyToClipboard(addr)
    },
  },
})

const app = new Vue({
  router,
  vuetify,
  i18n,
  store,
  render: (h) => h(App),
})
app.$toast.init(store)
app.$mount('#app')
